// GETs a Turbo Stream endpoint and applies the streamed updates.
export async function fetchTurboStream (url) {
  const response = await fetch(url, { headers: { Accept: "text/vnd.turbo-stream.html" } })
  if (!response.ok) return false

  window.Turbo.renderStreamMessage(await response.text())
  return true
}
